<template>
 <div class="slider">
  
    <div class="slides">
      <div class="overlay hidden-xs hidden-md"></div>
      <div
        v-for="(slide, index) in slider"
        :key="index"
        :class="['slide', { active: index === currentIndex }]"
      >
        <img class="hidden-xs hidden-sm" v-if="slide.insInstitucionalImagens[0].itgUrlImagem" :src="$imgURL + slide.insInstitucionalImagens[0].itgUrlImagem" :alt="`Imagem ${index + 1}`" style="width: 100%;  object-fit: cover;"/>
          
        <div class="caption">
            <div class="text w-100 mt-5">
              <span class="subheading">
                <h2>{{ slide.itiNome }}</h2>
              </span>
              <h1 v-html="slide.itiResumo1"></h1>
              <p v-html="slide.itiResumo2" ></p>
            </div>
        </div>
        <div class="overlay2 hidden-xs hidden-md"></div>
      </div>
    </div>
    <div class="navigation">
      <span
        v-for="(slide, index) in slider"
        :key="index"
        :class="['dot', { active: index === currentIndex }]"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "PageSlider2",
  components: {},
  data: () => ({
    slides: [],
    slider:[],
    currentIndex: 0,
    percent: 0,
    interval: null,
  }),
  mounted() {
    this.startSlider();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    
    startSlider() {
      this.interval = setInterval(() => {
        this.nextSlide();
      }, 7000); // Timer de 5 segundos
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slider.length;
    },
    goToSlide(index) {
      clearInterval(this.interval);
      this.currentIndex = index;
      this.startSlider(); // Reinicia o timer após clicar
    },
  },
  async created() {

    
    //sliders
		axios.get('/Process/InsInstitucional/institucional/34/slider/0/x')
			.then(response => {
				this.slider = response.data.filter(x=>x.itiVisivel).sort((a, b) => {
						const valorA = parseInt(a.itiOrdem) || 0;
						const valorB = parseInt(b.itiOrdem) || 0;
						return valorA - valorB;
					});

          //console.log('this.slider')
          //console.log(this.slider)
				
			})
			.catch(error => {
				console.error(error);
			});
 
  },
};
</script>

<style>
/* Slider container */
.slider {
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
}

.slider .overlay {
  position: absolute;
  top: 150;
  left: 0;
  width: 100%;
  height: 130px; /* Ajuste a altura conforme necessário */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0)); /* Gradiente que vai de preto transparente */
  z-index: 1; /* Certifique-se de que esteja acima do conteúdo */
}

/* Slides */
.slides {
  display: flex;
  position: relative;
}

/* Individual slide */
.slide {
  min-width: 100%;
  position: absolute;
  opacity: 0;
  transition: opacity 1s ease;
}

.slide.active {
  opacity: 1;
  position: relative;
}

/* Image in the slide */
.slide img {
  width: 100%;
  height: 700px;
  transition: transform 40s ease; /* Transição suave para o zoom */
  transform: scale(1); /* Escala inicial */
}

.slide.active img {
  transform: scale(1.1); /* Aumenta a imagem quando a slide está ativa */
}

/* Text in the bottom-left corner */
.caption {
  position: absolute;
  bottom: 110px;
  top: 200px;
  left: 150px;
  color: white;
  font-size: 18px;
  background-color: rgba(90, 90, 93, 0.5);
  padding: 20px;
  border-radius: 5px;
  font-weight: 500;
  width: 700px;
  /*text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);*/
}

.caption p {
  bottom: 30px;
  left: 20px;
  color: white;
  font-size: 18px;
  border-radius: 5px;
  font-weight: 300;
  
  /*text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);*/
  margin: 0px;
}
.caption h2 {
  color: rgb(255, 153, 0);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 5;
  margin-bottom: 10;
  /*text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);*/
}

.caption h1 p {
  color: white;
  font-size: 52px !important;
  font-weight: 800;
  /*text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);*/
}

/* Navigation dots */
.navigation {
  text-align: left;
  margin-left: 20px;
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #333;
  border-radius: 5px;
  width: 15px;
  height: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}

.dot.active {
  background-color: #ffffff;
  width: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

@media (max-width:767px) {
/* Text in the bottom-left corner */
.caption {
  position: absolute;
  bottom: 30px;
  left: 20px;
  color: white;
  font-size: 12px;
  background-color: rgba(90, 90, 93, 0.5);
  padding: 10px;
  border-radius: 5px;
  font-weight: 500;
  width: 250px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}
.caption h2 {
  color: white;
  font-size: 20px;
  font-weight: 800;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #333;
  border-radius: 5px;
  width: 8px;
  height: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}

.dot.active {
  background-color: #ffffff;
  width: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
}


</style>